import React, { useEffect, useState } from 'react'
import styles from './TeaserOverlay.module.sass'
import ATLogo from '../../assets/AT.png'

function TeaserOverlay({ onCompleted }: { onCompleted?: () => void }) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // Start fade out after 2.5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 2500)

    return () => clearTimeout(timer)
  }, [])

  const handleTransitionEnd = () => {
    if (!isVisible && onCompleted) {
      onCompleted()
    }
  }

  return (
    <div 
      className={styles.container}
      style={{
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 1.5s ease-out',
        background: 'rgb(23, 23, 30)', // ✅ same color, fully opaque
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw'
      }}
      onTransitionEnd={handleTransitionEnd}
    >
      <img
        src={ATLogo}
        alt="AT Logo"
        style={{
          width: '200px',
          height: 'auto',
          objectFit: 'contain'
        }}
      />
    </div>
  )
}

export default TeaserOverlay
